import { useEffect } from "react";
import history from "../../services/history";
import store from "../../store";
import { track, mapProductsToItems, sumItemsValue } from "../../analytics";

// Dispara page_view a cada troca de rota (SPA) e os eventos de funil que dependem
// da navegação (begin_checkout ao entrar no checkout; add_payment_info na rota de
// pagamento), já que não existe action Redux para "entrar no checkout".
//
// Flag por sessão para emitir begin_checkout apenas uma vez por entrada no fluxo.
let checkoutStarted = false;

function cartItemsAndValue() {
  const state = store.getState();
  const cart = state?.cart?.data;
  const hasFidelidade = state?.user?.profile?.programa_fidelidade || false;
  const items = mapProductsToItems(cart?.itens || [], hasFidelidade);
  const value = state?.cart?.amount || sumItemsValue(items);
  return { items, value };
}

function handleLocation(location) {
  const path = (location && location.pathname) || "/";

  track("page_view", { page_path: path, page_location: window.location.href });

  if (/^\/carrinho/.test(path)) {
    track("view_cart", cartItemsAndValue());
  }

  if (/^\/checkout(\/|$)/.test(path)) {
    if (!checkoutStarted) {
      checkoutStarted = true;
      track("begin_checkout", cartItemsAndValue());
    }
    if (/^\/checkout\/pagamento/.test(path)) {
      track("add_payment_info", cartItemsAndValue());
    }
  } else {
    // Saiu do checkout -> permite novo begin_checkout numa próxima entrada.
    checkoutStarted = false;
  }
}

export default function AnalyticsRouteTracker() {
  useEffect(() => {
    handleLocation(history.location); // page_view inicial
    const unlisten = history.listen((location) => handleLocation(location));
    return () => unlisten();
  }, []);

  return null;
}
